import React from 'react'
import { 
    MainContent, 
    MainWrapper, 
    MidHR,
    FAQHeader,
    AccordianView
} from './styles';
import AccordianComponent from './AccordianComponent';
import { FAQArray } from './FAQObject';

const FAQS = () => {
    
    const renderView = () => <MainWrapper id="faqs">
        <MainContent flexDirection='column'>
          <FAQHeader>Tata Neu HDFC Bank Credit Card FAQs</FAQHeader>
          <MidHR />
          {FAQArray.map((item, index) => <AccordianView key={index}>
              <AccordianComponent 
                accordianHeader={item.header}
                data={item.data}
              /> 
            </AccordianView>
        )}
        </MainContent>
    </MainWrapper>

    return renderView();
}

export default FAQS
